/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Conversion Reporting API
 * API for querying conversion and reporting data from PostgreSQL.

## Reporting (Async Query Pattern)
Reporting and lead-export queries use an async job-polling pattern:

1. **Submit** a query via `POST /reporting/queries` -- returns a `queryId` immediately
2. **Poll** status via `GET /reporting/queries/{queryId}` until `status` is `completed`
3. **Results** are included inline in the status response when complete
4. **Cancel** a running query via `DELETE /reporting/queries/{queryId}`

## Pagination
Reporting results support both offset-based and cursor-based pagination.
Cursor-based pagination (`nextCursor`) is recommended for large datasets.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

import type {
  AdvancedTargetingRunTriggeredDto,
  AdvancedTargetingRunsResponseDto,
  AdvancedTargetingSettingsDto,
  ApiCampaignsResponseDto,
  ApiCatalogParams,
  ApiCatalogResponseDto,
  ApiCostAssessmentDto,
  ApiDimensionValuesParams,
  ApiKeyDto,
  ApiReportResponseDto,
  ApiRequestLogDto,
  AttributionRefreshRequestDto,
  BatchDetailResponseDto,
  BatchListResponseDto,
  CampaignAccessByCampaignDto,
  CampaignAccessRemovedResponseDto,
  CampaignDeletedResponseDto,
  CampaignDto,
  CampaignListResponseDto,
  CampaignReportingConfigDto,
  ConversionUploadRequestDto,
  CreateApiKeyDto,
  CreateCampaignDto,
  CreatedApiKeyDto,
  DashboardCatalogueDto,
  DashboardPacingDto,
  DashboardTimeseriesDto,
  DashboardWindowDataDto,
  DimensionValuesResponseDto,
  DimensionsMetadataResponseDto,
  ExplainPredictionModelParams,
  ExplorerCatalogueDto,
  ExplorerResultDto,
  ExplorerRowDetailDto,
  GetAdvancedTargetingLogsParams,
  GetAllCampaignAccessMap200,
  GetAllCampaignsParams,
  GetConversionUploadMissingDaysParams,
  GetConversionUploadTemplateParams,
  GetCrossroadsTieringLogsParams,
  GetDashboardCatalogueParams,
  GetDashboardPacingParams,
  GetDashboardTimeseriesParams,
  GetDashboardWindowParams,
  GetDimensionValuesParams,
  GetExplorerCatalogueParams,
  GetExplorerParams,
  GetExplorerRowParams,
  GetExplorerValuesParams,
  GetForecastAccuracyParams,
  GetForecastAsOfParams,
  GetForecastMethodsParams,
  GetPredictionHistoryParams,
  GetPredictionSeriesParams,
  GetPublisherRosterParams,
  LeadIdsQueryRequestDto,
  LevelConservationDto,
  ListConversionUploadBatchesParams,
  MetricsMetadataResponseDto,
  MissingVerifiedInstallDaysResponseDto,
  OrganizationCampaignsDto,
  OrganizationListItemDto,
  PingResponseDto,
  PredictionSeriesResponseDto,
  PublisherRosterDto,
  QueryStatusResponseDto,
  QuerySubmittedResponseDto,
  ReportingExportRequestDto,
  ReportingQueryRequestDto,
  RetireCrossroadsStateRowsParams,
  RunForecastBackcastParams,
  RunImpressionBackfillParams,
  RunPredictionBackfillParams,
  RunPredictionMaterialiseParams,
  RunPredictionSnapshotParams,
  TriggerAdvancedTargetingRunParams,
  TriggerCrossroadsTieringRunParams,
  UpdateAdvancedTargetingSettingsDto,
  UpdateCampaignAccessDto,
  UpdateCampaignDto,
  UpdateCampaignReportingConfigDto,
  UploadAcceptedResponseDto,
  VerifyPredictionConservationParams
} from './models';

import { customInstance } from '../axiosInstance';
import type { ErrorType , BodyType } from '../axiosInstance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const appControllerLogout = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/app/logout`, method: 'GET', signal
    },
      options);
    }
  



export const getAppControllerLogoutQueryKey = () => {
    return [
    `/app/logout`
    ] as const;
    }

    
export const getAppControllerLogoutQueryOptions = <TData = Awaited<ReturnType<typeof appControllerLogout>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerLogout>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerLogoutQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerLogout>>> = ({ signal }) => appControllerLogout(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerLogout>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerLogout>>>
export type AppControllerLogoutQueryError = ErrorType<unknown>



export function useAppControllerLogout<TData = Awaited<ReturnType<typeof appControllerLogout>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerLogout>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAppControllerLogoutQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const appControllerGetUserDetailsMulti = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/app/me_multi`, method: 'GET', signal
    },
      options);
    }
  



export const getAppControllerGetUserDetailsMultiQueryKey = () => {
    return [
    `/app/me_multi`
    ] as const;
    }

    
export const getAppControllerGetUserDetailsMultiQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetUserDetailsMultiQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>> = ({ signal }) => appControllerGetUserDetailsMulti(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerGetUserDetailsMultiQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>>
export type AppControllerGetUserDetailsMultiQueryError = ErrorType<unknown>



export function useAppControllerGetUserDetailsMulti<TData = Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserDetailsMulti>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAppControllerGetUserDetailsMultiQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





export const appControllerSetCookie = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/app/set-cookie`, method: 'POST', signal
    },
      options);
    }
  


export const getAppControllerSetCookieMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerSetCookie>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof appControllerSetCookie>>, TError,void, TContext> => {

const mutationKey = ['appControllerSetCookie'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appControllerSetCookie>>, void> = () => {
          

          return  appControllerSetCookie(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AppControllerSetCookieMutationResult = NonNullable<Awaited<ReturnType<typeof appControllerSetCookie>>>
    
    export type AppControllerSetCookieMutationError = ErrorType<unknown>

    export const useAppControllerSetCookie = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerSetCookie>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof appControllerSetCookie>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAppControllerSetCookieMutationOptions(options));
    }
    
/**
 * Submit an async reporting query. Returns a queryId to poll for results.
 * @summary Submit a reporting query
 */
export const submitReportingQuery = (
    reportingQueryRequestDto: BodyType<ReportingQueryRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuerySubmittedResponseDto>(
      {url: `/reporting/queries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportingQueryRequestDto, signal
    },
      options);
    }
  


export const getSubmitReportingQueryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReportingQuery>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitReportingQuery>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext> => {

const mutationKey = ['submitReportingQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitReportingQuery>>, {data: BodyType<ReportingQueryRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  submitReportingQuery(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitReportingQueryMutationResult = NonNullable<Awaited<ReturnType<typeof submitReportingQuery>>>
    export type SubmitReportingQueryMutationBody = BodyType<ReportingQueryRequestDto>
    export type SubmitReportingQueryMutationError = ErrorType<void>

    /**
 * @summary Submit a reporting query
 */
export const useSubmitReportingQuery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReportingQuery>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitReportingQuery>>,
        TError,
        {data: BodyType<ReportingQueryRequestDto>},
        TContext
      > => {
      return useMutation(getSubmitReportingQueryMutationOptions(options));
    }
    
/**
 * Submit an async CSV export. Runs the report aggregate ONCE (not per page) and streams the full result to a server-side CSV file; poll for the queryId, then GET queries/{queryId}/download.
 * @summary Submit a CSV export query
 */
export const submitReportingExport = (
    reportingExportRequestDto: BodyType<ReportingExportRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuerySubmittedResponseDto>(
      {url: `/reporting/queries/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportingExportRequestDto, signal
    },
      options);
    }
  


export const getSubmitReportingExportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReportingExport>>, TError,{data: BodyType<ReportingExportRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitReportingExport>>, TError,{data: BodyType<ReportingExportRequestDto>}, TContext> => {

const mutationKey = ['submitReportingExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitReportingExport>>, {data: BodyType<ReportingExportRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  submitReportingExport(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitReportingExportMutationResult = NonNullable<Awaited<ReturnType<typeof submitReportingExport>>>
    export type SubmitReportingExportMutationBody = BodyType<ReportingExportRequestDto>
    export type SubmitReportingExportMutationError = ErrorType<void>

    /**
 * @summary Submit a CSV export query
 */
export const useSubmitReportingExport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitReportingExport>>, TError,{data: BodyType<ReportingExportRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitReportingExport>>,
        TError,
        {data: BodyType<ReportingExportRequestDto>},
        TContext
      > => {
      return useMutation(getSubmitReportingExportMutationOptions(options));
    }
    
/**
 * Streams the CSV file produced by a completed export query.
 * @summary Download a completed export's CSV file
 */
export const downloadReportingExport = (
    queryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/reporting/queries/${queryId}/download`, method: 'GET', signal
    },
      options);
    }
  



export const getDownloadReportingExportQueryKey = (queryId: string,) => {
    return [
    `/reporting/queries/${queryId}/download`
    ] as const;
    }

    
export const getDownloadReportingExportQueryOptions = <TData = Awaited<ReturnType<typeof downloadReportingExport>>, TError = ErrorType<void>>(queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadReportingExport>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadReportingExportQueryKey(queryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadReportingExport>>> = ({ signal }) => downloadReportingExport(queryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadReportingExport>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadReportingExportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadReportingExport>>>
export type DownloadReportingExportQueryError = ErrorType<void>


/**
 * @summary Download a completed export's CSV file
 */

export function useDownloadReportingExport<TData = Awaited<ReturnType<typeof downloadReportingExport>>, TError = ErrorType<void>>(
 queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadReportingExport>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadReportingExportQueryOptions(queryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Submit an async query to export distinct Lead IDs. Returns a queryId to poll for results.
 * @summary Submit a lead IDs export query
 */
export const submitLeadIdsQuery = (
    leadIdsQueryRequestDto: BodyType<LeadIdsQueryRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuerySubmittedResponseDto>(
      {url: `/reporting/queries/lead-ids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leadIdsQueryRequestDto, signal
    },
      options);
    }
  


export const getSubmitLeadIdsQueryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLeadIdsQuery>>, TError,{data: BodyType<LeadIdsQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitLeadIdsQuery>>, TError,{data: BodyType<LeadIdsQueryRequestDto>}, TContext> => {

const mutationKey = ['submitLeadIdsQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLeadIdsQuery>>, {data: BodyType<LeadIdsQueryRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  submitLeadIdsQuery(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitLeadIdsQueryMutationResult = NonNullable<Awaited<ReturnType<typeof submitLeadIdsQuery>>>
    export type SubmitLeadIdsQueryMutationBody = BodyType<LeadIdsQueryRequestDto>
    export type SubmitLeadIdsQueryMutationError = ErrorType<void>

    /**
 * @summary Submit a lead IDs export query
 */
export const useSubmitLeadIdsQuery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLeadIdsQuery>>, TError,{data: BodyType<LeadIdsQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitLeadIdsQuery>>,
        TError,
        {data: BodyType<LeadIdsQueryRequestDto>},
        TContext
      > => {
      return useMutation(getSubmitLeadIdsQueryMutationOptions(options));
    }
    
/**
 * Recalculate V2 attribution for a rolling conversion window using a wider pixel lookback window.
 * @summary Submit a V2 attribution refresh
 */
export const submitAttributionRefresh = (
    attributionRefreshRequestDto: BodyType<AttributionRefreshRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuerySubmittedResponseDto>(
      {url: `/reporting/attribution-refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: attributionRefreshRequestDto, signal
    },
      options);
    }
  


export const getSubmitAttributionRefreshMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAttributionRefresh>>, TError,{data: BodyType<AttributionRefreshRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAttributionRefresh>>, TError,{data: BodyType<AttributionRefreshRequestDto>}, TContext> => {

const mutationKey = ['submitAttributionRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAttributionRefresh>>, {data: BodyType<AttributionRefreshRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  submitAttributionRefresh(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitAttributionRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof submitAttributionRefresh>>>
    export type SubmitAttributionRefreshMutationBody = BodyType<AttributionRefreshRequestDto>
    export type SubmitAttributionRefreshMutationError = ErrorType<void>

    /**
 * @summary Submit a V2 attribution refresh
 */
export const useSubmitAttributionRefresh = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAttributionRefresh>>, TError,{data: BodyType<AttributionRefreshRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitAttributionRefresh>>,
        TError,
        {data: BodyType<AttributionRefreshRequestDto>},
        TContext
      > => {
      return useMutation(getSubmitAttributionRefreshMutationOptions(options));
    }
    
/**
 * Poll the status of a submitted query. Results are included when completed.
 * @summary Get query status and results
 */
export const getQueryStatus = (
    queryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QueryStatusResponseDto>(
      {url: `/reporting/queries/${queryId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetQueryStatusQueryKey = (queryId: string,) => {
    return [
    `/reporting/queries/${queryId}`
    ] as const;
    }

    
export const getGetQueryStatusQueryOptions = <TData = Awaited<ReturnType<typeof getQueryStatus>>, TError = ErrorType<void>>(queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueryStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueryStatusQueryKey(queryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQueryStatus>>> = ({ signal }) => getQueryStatus(queryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(queryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQueryStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQueryStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getQueryStatus>>>
export type GetQueryStatusQueryError = ErrorType<void>


/**
 * @summary Get query status and results
 */

export function useGetQueryStatus<TData = Awaited<ReturnType<typeof getQueryStatus>>, TError = ErrorType<void>>(
 queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueryStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQueryStatusQueryOptions(queryId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Cancel a running query or delete a completed one. A running attribution refresh cannot be cancelled.
 * @summary Cancel or delete a query
 */
export const cancelQuery = (
    queryId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/reporting/queries/${queryId}`, method: 'DELETE', signal
    },
      options);
    }
  


export const getCancelQueryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelQuery>>, TError,{queryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelQuery>>, TError,{queryId: string}, TContext> => {

const mutationKey = ['cancelQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelQuery>>, {queryId: string}> = (props) => {
          const {queryId} = props ?? {};

          return  cancelQuery(queryId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CancelQueryMutationResult = NonNullable<Awaited<ReturnType<typeof cancelQuery>>>
    
    export type CancelQueryMutationError = ErrorType<void>

    /**
 * @summary Cancel or delete a query
 */
export const useCancelQuery = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelQuery>>, TError,{queryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelQuery>>,
        TError,
        {queryId: string},
        TContext
      > => {
      return useMutation(getCancelQueryMutationOptions(options));
    }
    
/**
 * Returns the list of available dimensions for reporting queries.
 * @summary Get available dimensions
 */
export const getAvailableDimensions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DimensionsMetadataResponseDto>(
      {url: `/reporting/dimensions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAvailableDimensionsQueryKey = () => {
    return [
    `/reporting/dimensions`
    ] as const;
    }

    
export const getGetAvailableDimensionsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableDimensions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableDimensions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableDimensionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableDimensions>>> = ({ signal }) => getAvailableDimensions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableDimensions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAvailableDimensionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableDimensions>>>
export type GetAvailableDimensionsQueryError = ErrorType<unknown>


/**
 * @summary Get available dimensions
 */

export function useGetAvailableDimensions<TData = Awaited<ReturnType<typeof getAvailableDimensions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableDimensions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAvailableDimensionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns the list of available metrics for reporting queries.
 * @summary Get available metrics
 */
export const getAvailableMetrics = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MetricsMetadataResponseDto>(
      {url: `/reporting/metrics`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAvailableMetricsQueryKey = () => {
    return [
    `/reporting/metrics`
    ] as const;
    }

    
export const getGetAvailableMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableMetrics>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableMetricsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableMetrics>>> = ({ signal }) => getAvailableMetrics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAvailableMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableMetrics>>>
export type GetAvailableMetricsQueryError = ErrorType<unknown>


/**
 * @summary Get available metrics
 */

export function useGetAvailableMetrics<TData = Awaited<ReturnType<typeof getAvailableMetrics>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAvailableMetricsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns distinct values for a specific dimension within a date range.
 * @summary Get distinct values for a dimension
 */
export const getDimensionValues = (
    params: GetDimensionValuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DimensionValuesResponseDto>(
      {url: `/reporting/dimension-values`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDimensionValuesQueryKey = (params?: GetDimensionValuesParams,) => {
    return [
    `/reporting/dimension-values`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDimensionValuesQueryOptions = <TData = Awaited<ReturnType<typeof getDimensionValues>>, TError = ErrorType<void>>(params: GetDimensionValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDimensionValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDimensionValuesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDimensionValues>>> = ({ signal }) => getDimensionValues(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDimensionValues>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDimensionValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getDimensionValues>>>
export type GetDimensionValuesQueryError = ErrorType<void>


/**
 * @summary Get distinct values for a dimension
 */

export function useGetDimensionValues<TData = Awaited<ReturnType<typeof getDimensionValues>>, TError = ErrorType<void>>(
 params: GetDimensionValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDimensionValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDimensionValuesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * One point per impression date per cohort, spanning twice the attribution window: the still-accruing dates, projected from partial observations, and the future dates, forecast from cohort history. Matured dates are excluded because they are what the curve is fitted on.
 * @summary Predicted conversions per impression date
 */
export const getPredictionSeries = (
    params: GetPredictionSeriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PredictionSeriesResponseDto>(
      {url: `/prediction/series`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPredictionSeriesQueryKey = (params?: GetPredictionSeriesParams,) => {
    return [
    `/prediction/series`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPredictionSeriesQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionSeries>>, TError = ErrorType<void>>(params: GetPredictionSeriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPredictionSeries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionSeriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionSeries>>> = ({ signal }) => getPredictionSeries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionSeries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPredictionSeriesQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionSeries>>>
export type GetPredictionSeriesQueryError = ErrorType<void>


/**
 * @summary Predicted conversions per impression date
 */

export function useGetPredictionSeries<TData = Awaited<ReturnType<typeof getPredictionSeries>>, TError = ErrorType<void>>(
 params: GetPredictionSeriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPredictionSeries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPredictionSeriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Runs the daily maturation snapshot for a given conversion date. Idempotent, so re-running a date costs nothing — this is how a day the cron missed gets filled.
 * @summary Snapshot one conversion day
 */
export const runPredictionSnapshot = (
    params: RunPredictionSnapshotParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/snapshot`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRunPredictionSnapshotMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionSnapshot>>, TError,{params: RunPredictionSnapshotParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runPredictionSnapshot>>, TError,{params: RunPredictionSnapshotParams}, TContext> => {

const mutationKey = ['runPredictionSnapshot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPredictionSnapshot>>, {params: RunPredictionSnapshotParams}> = (props) => {
          const {params} = props ?? {};

          return  runPredictionSnapshot(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunPredictionSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof runPredictionSnapshot>>>
    
    export type RunPredictionSnapshotMutationError = ErrorType<void>

    /**
 * @summary Snapshot one conversion day
 */
export const useRunPredictionSnapshot = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionSnapshot>>, TError,{params: RunPredictionSnapshotParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runPredictionSnapshot>>,
        TError,
        {params: RunPredictionSnapshotParams},
        TContext
      > => {
      return useMutation(getRunPredictionSnapshotMutationOptions(options));
    }
    
/**
 * Reconstructs each age from conversion timestamps. Sound because raw ingest lands within seconds, so a conversion's fractional credit never changes after the fact. Never overwrites forward-collected rows.
 * @summary Load maturation history for a date range
 */
export const runPredictionBackfill = (
    params: RunPredictionBackfillParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/backfill`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRunPredictionBackfillMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionBackfill>>, TError,{params: RunPredictionBackfillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runPredictionBackfill>>, TError,{params: RunPredictionBackfillParams}, TContext> => {

const mutationKey = ['runPredictionBackfill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPredictionBackfill>>, {params: RunPredictionBackfillParams}> = (props) => {
          const {params} = props ?? {};

          return  runPredictionBackfill(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunPredictionBackfillMutationResult = NonNullable<Awaited<ReturnType<typeof runPredictionBackfill>>>
    
    export type RunPredictionBackfillMutationError = ErrorType<void>

    /**
 * @summary Load maturation history for a date range
 */
export const useRunPredictionBackfill = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionBackfill>>, TError,{params: RunPredictionBackfillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runPredictionBackfill>>,
        TError,
        {params: RunPredictionBackfillParams},
        TContext
      > => {
      return useMutation(getRunPredictionBackfillMutationOptions(options));
    }
    
/**
 * Every estimate recorded for each impression date, newest first, with the horizon it was made at. Compare against the same cohort's settled total to see how the model has actually done — the reason the estimates are kept rather than overwritten.
 * @summary What we predicted for a date, and when we predicted it
 */
export const getPredictionHistory = (
    params: GetPredictionHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/history`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPredictionHistoryQueryKey = (params?: GetPredictionHistoryParams,) => {
    return [
    `/prediction/history`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPredictionHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getPredictionHistory>>, TError = ErrorType<void>>(params: GetPredictionHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPredictionHistory>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPredictionHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPredictionHistory>>> = ({ signal }) => getPredictionHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPredictionHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPredictionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPredictionHistory>>>
export type GetPredictionHistoryQueryError = ErrorType<void>


/**
 * @summary What we predicted for a date, and when we predicted it
 */

export function useGetPredictionHistory<TData = Awaited<ReturnType<typeof getPredictionHistory>>, TError = ErrorType<void>>(
 params: GetPredictionHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPredictionHistory>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPredictionHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Every estimate recorded on the given day, with what each date actually settled at beside it. Reconstructs what we were saying that morning, so it can be read against what happened — the live series can only ever show what we think now.
 * @summary The forward view as it stood on a past day
 */
export const getForecastAsOf = (
    params: GetForecastAsOfParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/as-of`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetForecastAsOfQueryKey = (params?: GetForecastAsOfParams,) => {
    return [
    `/prediction/as-of`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetForecastAsOfQueryOptions = <TData = Awaited<ReturnType<typeof getForecastAsOf>>, TError = ErrorType<void>>(params: GetForecastAsOfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAsOf>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastAsOfQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastAsOf>>> = ({ signal }) => getForecastAsOf(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastAsOf>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastAsOfQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastAsOf>>>
export type GetForecastAsOfQueryError = ErrorType<void>


/**
 * @summary The forward view as it stood on a past day
 */

export function useGetForecastAsOf<TData = Awaited<ReturnType<typeof getForecastAsOf>>, TError = ErrorType<void>>(
 params: GetForecastAsOfParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAsOf>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastAsOfQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * What the deployed model is actually doing, for the explainer the team reads. Served rather than written down: a documented constant and a deployed one drift apart on the first change, and nobody finds out from the document.
 * @summary The parameters the model is running on
 */
export const explainPredictionModel = (
    params: ExplainPredictionModelParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/explain`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getExplainPredictionModelQueryKey = (params?: ExplainPredictionModelParams,) => {
    return [
    `/prediction/explain`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getExplainPredictionModelQueryOptions = <TData = Awaited<ReturnType<typeof explainPredictionModel>>, TError = ErrorType<void>>(params: ExplainPredictionModelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof explainPredictionModel>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExplainPredictionModelQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof explainPredictionModel>>> = ({ signal }) => explainPredictionModel(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof explainPredictionModel>>, TError, TData> & { queryKey: QueryKey }
}

export type ExplainPredictionModelQueryResult = NonNullable<Awaited<ReturnType<typeof explainPredictionModel>>>
export type ExplainPredictionModelQueryError = ErrorType<void>


/**
 * @summary The parameters the model is running on
 */

export function useExplainPredictionModel<TData = Awaited<ReturnType<typeof explainPredictionModel>>, TError = ErrorType<void>>(
 params: ExplainPredictionModelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof explainPredictionModel>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExplainPredictionModelQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * One entry per model, with the span of days it recorded over. A model added later was replayed across a shorter range, so each one bounds its own date picker rather than sharing one.
 * @summary Which models have a recorded forward view
 */
export const getForecastMethods = (
    params: GetForecastMethodsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/methods`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetForecastMethodsQueryKey = (params?: GetForecastMethodsParams,) => {
    return [
    `/prediction/methods`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetForecastMethodsQueryOptions = <TData = Awaited<ReturnType<typeof getForecastMethods>>, TError = ErrorType<void>>(params: GetForecastMethodsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastMethodsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastMethods>>> = ({ signal }) => getForecastMethods(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastMethods>>>
export type GetForecastMethodsQueryError = ErrorType<void>


/**
 * @summary Which models have a recorded forward view
 */

export function useGetForecastMethods<TData = Awaited<ReturnType<typeof getForecastMethods>>, TError = ErrorType<void>>(
 params: GetForecastMethodsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastMethodsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * How wrong the recorded forecasts turned out to be, grouped by how far ahead they were looking. Restricted to impression dates whose attribution window has closed: an unsettled date has no answer to be wrong about. Absolute error for magnitude, signed bias for direction.
 * @summary Measured forecast error by horizon
 */
export const getForecastAccuracy = (
    params: GetForecastAccuracyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/accuracy`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetForecastAccuracyQueryKey = (params?: GetForecastAccuracyParams,) => {
    return [
    `/prediction/accuracy`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetForecastAccuracyQueryOptions = <TData = Awaited<ReturnType<typeof getForecastAccuracy>>, TError = ErrorType<void>>(params: GetForecastAccuracyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAccuracy>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastAccuracyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastAccuracy>>> = ({ signal }) => getForecastAccuracy(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastAccuracy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastAccuracyQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastAccuracy>>>
export type GetForecastAccuracyQueryError = ErrorType<void>


/**
 * @summary Measured forecast error by horizon
 */

export function useGetForecastAccuracy<TData = Awaited<ReturnType<typeof getForecastAccuracy>>, TError = ErrorType<void>>(
 params: GetForecastAccuracyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAccuracy>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastAccuracyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Scores every recorded forecast whose date has settled and writes the result to the error profile, one row per horizon. The nightly job does this too — this is the way to get a reading without waiting for it, or to correct a night that was missed.
 * @summary Measure and record forecast error
 */
export const runForecastScoring = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/score`, method: 'POST', signal
    },
      options);
    }
  


export const getRunForecastScoringMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastScoring>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runForecastScoring>>, TError,void, TContext> => {

const mutationKey = ['runForecastScoring'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runForecastScoring>>, void> = () => {
          

          return  runForecastScoring(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunForecastScoringMutationResult = NonNullable<Awaited<ReturnType<typeof runForecastScoring>>>
    
    export type RunForecastScoringMutationError = ErrorType<unknown>

    /**
 * @summary Measure and record forecast error
 */
export const useRunForecastScoring = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastScoring>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runForecastScoring>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunForecastScoringMutationOptions(options));
    }
    
/**
 * Writes what the grid would have merged in, so the column can be ordered by in SQL. The nightly job only covers the window whose estimate can still move; this fills everything older. Run after the maturation backfill, and re-run it after any attribution re-derivation of old dates.
 * @summary Materialise the current estimate for a date range
 */
export const runPredictionMaterialise = (
    params: RunPredictionMaterialiseParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/backfill-predictions`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRunPredictionMaterialiseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionMaterialise>>, TError,{params: RunPredictionMaterialiseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runPredictionMaterialise>>, TError,{params: RunPredictionMaterialiseParams}, TContext> => {

const mutationKey = ['runPredictionMaterialise'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPredictionMaterialise>>, {params: RunPredictionMaterialiseParams}> = (props) => {
          const {params} = props ?? {};

          return  runPredictionMaterialise(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunPredictionMaterialiseMutationResult = NonNullable<Awaited<ReturnType<typeof runPredictionMaterialise>>>
    
    export type RunPredictionMaterialiseMutationError = ErrorType<void>

    /**
 * @summary Materialise the current estimate for a date range
 */
export const useRunPredictionMaterialise = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPredictionMaterialise>>, TError,{params: RunPredictionMaterialiseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runPredictionMaterialise>>,
        TError,
        {params: RunPredictionMaterialiseParams},
        TContext
      > => {
      return useMutation(getRunPredictionMaterialiseMutationOptions(options));
    }
    
/**
 * Faithful rather than approximate: a forecast reads only fully matured dates, whose every age was already known then. Rows are labelled apart from live forecasts and stamped with the day they represent, so scoring keeps its horizon. Run after the maturation backfill.
 * @summary Replay the forecasts each past day would have produced
 */
export const runForecastBackcast = (
    params: RunForecastBackcastParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/backfill-forecasts`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRunForecastBackcastMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastBackcast>>, TError,{params: RunForecastBackcastParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runForecastBackcast>>, TError,{params: RunForecastBackcastParams}, TContext> => {

const mutationKey = ['runForecastBackcast'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runForecastBackcast>>, {params: RunForecastBackcastParams}> = (props) => {
          const {params} = props ?? {};

          return  runForecastBackcast(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunForecastBackcastMutationResult = NonNullable<Awaited<ReturnType<typeof runForecastBackcast>>>
    
    export type RunForecastBackcastMutationError = ErrorType<void>

    /**
 * @summary Replay the forecasts each past day would have produced
 */
export const useRunForecastBackcast = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runForecastBackcast>>, TError,{params: RunForecastBackcastParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runForecastBackcast>>,
        TError,
        {params: RunForecastBackcastParams},
        TContext
      > => {
      return useMutation(getRunForecastBackcastMutationOptions(options));
    }
    
/**
 * Reads raw pixels, because no served rollup carries app bundle, adset or state — so this is the expensive half and is worth running off-hours. Behind the scenes only: ad ops see the final predicted total per event, not these inputs.
 * @summary Load impressions, cost and revenue for a date range
 */
export const runImpressionBackfill = (
    params: RunImpressionBackfillParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/prediction/backfill-impressions`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRunImpressionBackfillMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runImpressionBackfill>>, TError,{params: RunImpressionBackfillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runImpressionBackfill>>, TError,{params: RunImpressionBackfillParams}, TContext> => {

const mutationKey = ['runImpressionBackfill'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runImpressionBackfill>>, {params: RunImpressionBackfillParams}> = (props) => {
          const {params} = props ?? {};

          return  runImpressionBackfill(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunImpressionBackfillMutationResult = NonNullable<Awaited<ReturnType<typeof runImpressionBackfill>>>
    
    export type RunImpressionBackfillMutationError = ErrorType<void>

    /**
 * @summary Load impressions, cost and revenue for a date range
 */
export const useRunImpressionBackfill = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runImpressionBackfill>>, TError,{params: RunImpressionBackfillParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runImpressionBackfill>>,
        TError,
        {params: RunImpressionBackfillParams},
        TContext
      > => {
      return useMutation(getRunImpressionBackfillMutationOptions(options));
    }
    
/**
 * Every one of the sixteen levels must report an identical total. Any disagreement means a write duplicated or dropped cells, and is the cheapest check that stored data is sound.
 * @summary Check credit is conserved across grouping levels
 */
export const verifyPredictionConservation = (
    params: VerifyPredictionConservationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LevelConservationDto[]>(
      {url: `/prediction/verify`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getVerifyPredictionConservationQueryKey = (params?: VerifyPredictionConservationParams,) => {
    return [
    `/prediction/verify`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getVerifyPredictionConservationQueryOptions = <TData = Awaited<ReturnType<typeof verifyPredictionConservation>>, TError = ErrorType<void>>(params: VerifyPredictionConservationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof verifyPredictionConservation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyPredictionConservationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyPredictionConservation>>> = ({ signal }) => verifyPredictionConservation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyPredictionConservation>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyPredictionConservationQueryResult = NonNullable<Awaited<ReturnType<typeof verifyPredictionConservation>>>
export type VerifyPredictionConservationQueryError = ErrorType<void>


/**
 * @summary Check credit is conserved across grouping levels
 */

export function useVerifyPredictionConservation<TData = Awaited<ReturnType<typeof verifyPredictionConservation>>, TError = ErrorType<void>>(
 params: VerifyPredictionConservationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof verifyPredictionConservation>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyPredictionConservationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Retrieve campaigns. Pass scope=organization to limit the result to campaigns the requesting organization has access to; omit it for every campaign.
 * @summary Get all campaigns
 */
export const getAllCampaigns = (
    params?: GetAllCampaignsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignListResponseDto>(
      {url: `/campaigns`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllCampaignsQueryKey = (params?: GetAllCampaignsParams,) => {
    return [
    `/campaigns`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAllCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof getAllCampaigns>>, TError = ErrorType<void>>(params?: GetAllCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllCampaigns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCampaignsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCampaigns>>> = ({ signal }) => getAllCampaigns(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCampaigns>>>
export type GetAllCampaignsQueryError = ErrorType<void>


/**
 * @summary Get all campaigns
 */

export function useGetAllCampaigns<TData = Awaited<ReturnType<typeof getAllCampaigns>>, TError = ErrorType<void>>(
 params?: GetAllCampaignsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllCampaigns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new campaign with a unique id_campaign (slug)
 * @summary Create a new campaign
 */
export const createCampaign = (
    createCampaignDto: BodyType<CreateCampaignDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignDto>(
      {url: `/campaigns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCampaignDto, signal
    },
      options);
    }
  


export const getCreateCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignDto>}, TContext> => {

const mutationKey = ['createCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCampaign>>, {data: BodyType<CreateCampaignDto>}> = (props) => {
          const {data} = props ?? {};

          return  createCampaign(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createCampaign>>>
    export type CreateCampaignMutationBody = BodyType<CreateCampaignDto>
    export type CreateCampaignMutationError = ErrorType<void>

    /**
 * @summary Create a new campaign
 */
export const useCreateCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCampaign>>,
        TError,
        {data: BodyType<CreateCampaignDto>},
        TContext
      > => {
      return useMutation(getCreateCampaignMutationOptions(options));
    }
    
/**
 * Retrieve a single campaign by its id_campaign
 * @summary Get campaign by ID
 */
export const getCampaignById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignDto>(
      {url: `/campaigns/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampaignByIdQueryKey = (id: string,) => {
    return [
    `/campaigns/${id}`
    ] as const;
    }

    
export const getGetCampaignByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignById>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignById>>> = ({ signal }) => getCampaignById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCampaignByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignById>>>
export type GetCampaignByIdQueryError = ErrorType<void>


/**
 * @summary Get campaign by ID
 */

export function useGetCampaignById<TData = Awaited<ReturnType<typeof getCampaignById>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCampaignByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update an existing campaign's details
 * @summary Update a campaign
 */
export const updateCampaign = (
    id: string,
    updateCampaignDto: BodyType<UpdateCampaignDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignDto>(
      {url: `/campaigns/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampaignDto, signal
    },
      options);
    }
  


export const getUpdateCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: string;data: BodyType<UpdateCampaignDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: string;data: BodyType<UpdateCampaignDto>}, TContext> => {

const mutationKey = ['updateCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampaign>>, {id: string;data: BodyType<UpdateCampaignDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCampaign(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaign>>>
    export type UpdateCampaignMutationBody = BodyType<UpdateCampaignDto>
    export type UpdateCampaignMutationError = ErrorType<void>

    /**
 * @summary Update a campaign
 */
export const useUpdateCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaign>>, TError,{id: string;data: BodyType<UpdateCampaignDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCampaign>>,
        TError,
        {id: string;data: BodyType<UpdateCampaignDto>},
        TContext
      > => {
      return useMutation(getUpdateCampaignMutationOptions(options));
    }
    
/**
 * Delete a campaign by its id_campaign
 * @summary Delete a campaign
 */
export const deleteCampaign = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignDeletedResponseDto>(
      {url: `/campaigns/${id}`, method: 'DELETE', signal
    },
      options);
    }
  


export const getDeleteCampaignMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCampaign(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaign>>>
    
    export type DeleteCampaignMutationError = ErrorType<void>

    /**
 * @summary Delete a campaign
 */
export const useDeleteCampaign = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaign>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCampaignMutationOptions(options));
    }
    
/**
 * Retrieve campaign reporting event and label configuration.
 * @summary Get campaign reporting configuration
 */
export const getCampaignReportingConfig = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignReportingConfigDto>(
      {url: `/campaigns/${id}/reporting-config`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampaignReportingConfigQueryKey = (id: string,) => {
    return [
    `/campaigns/${id}/reporting-config`
    ] as const;
    }

    
export const getGetCampaignReportingConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignReportingConfig>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignReportingConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignReportingConfigQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignReportingConfig>>> = ({ signal }) => getCampaignReportingConfig(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignReportingConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCampaignReportingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignReportingConfig>>>
export type GetCampaignReportingConfigQueryError = ErrorType<unknown>


/**
 * @summary Get campaign reporting configuration
 */

export function useGetCampaignReportingConfig<TData = Awaited<ReturnType<typeof getCampaignReportingConfig>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignReportingConfig>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCampaignReportingConfigQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update allowed events, event labels/order, and non-event metric labels.
 * @summary Update campaign reporting configuration
 */
export const updateCampaignReportingConfig = (
    id: string,
    updateCampaignReportingConfigDto: BodyType<UpdateCampaignReportingConfigDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignReportingConfigDto>(
      {url: `/campaigns/${id}/reporting-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampaignReportingConfigDto, signal
    },
      options);
    }
  


export const getUpdateCampaignReportingConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignReportingConfig>>, TError,{id: string;data: BodyType<UpdateCampaignReportingConfigDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampaignReportingConfig>>, TError,{id: string;data: BodyType<UpdateCampaignReportingConfigDto>}, TContext> => {

const mutationKey = ['updateCampaignReportingConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampaignReportingConfig>>, {id: string;data: BodyType<UpdateCampaignReportingConfigDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCampaignReportingConfig(id,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampaignReportingConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaignReportingConfig>>>
    export type UpdateCampaignReportingConfigMutationBody = BodyType<UpdateCampaignReportingConfigDto>
    export type UpdateCampaignReportingConfigMutationError = ErrorType<unknown>

    /**
 * @summary Update campaign reporting configuration
 */
export const useUpdateCampaignReportingConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignReportingConfig>>, TError,{id: string;data: BodyType<UpdateCampaignReportingConfigDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCampaignReportingConfig>>,
        TError,
        {id: string;data: BodyType<UpdateCampaignReportingConfigDto>},
        TContext
      > => {
      return useMutation(getUpdateCampaignReportingConfigMutationOptions(options));
    }
    
/**
 * Retrieve all active organizations for access management
 * @summary Get all organizations
 */
export const getAllOrganizations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationListItemDto[]>(
      {url: `/campaign-access/organizations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllOrganizationsQueryKey = () => {
    return [
    `/campaign-access/organizations`
    ] as const;
    }

    
export const getGetAllOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOrganizations>>> = ({ signal }) => getAllOrganizations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizations>>>
export type GetAllOrganizationsQueryError = ErrorType<void>


/**
 * @summary Get all organizations
 */

export function useGetAllOrganizations<TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns a map of campaign IDs to arrays of organization IDs (pure PostgreSQL, no name resolution)
 * @summary Get all campaign-to-org-ID mappings
 */
export const getAllCampaignAccessMap = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAllCampaignAccessMap200>(
      {url: `/campaign-access/map`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllCampaignAccessMapQueryKey = () => {
    return [
    `/campaign-access/map`
    ] as const;
    }

    
export const getGetAllCampaignAccessMapQueryOptions = <TData = Awaited<ReturnType<typeof getAllCampaignAccessMap>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignAccessMap>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCampaignAccessMapQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCampaignAccessMap>>> = ({ signal }) => getAllCampaignAccessMap(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignAccessMap>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllCampaignAccessMapQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCampaignAccessMap>>>
export type GetAllCampaignAccessMapQueryError = ErrorType<void>


/**
 * @summary Get all campaign-to-org-ID mappings
 */

export function useGetAllCampaignAccessMap<TData = Awaited<ReturnType<typeof getAllCampaignAccessMap>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllCampaignAccessMap>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllCampaignAccessMapQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Retrieve all organizations that have access to a specific campaign
 * @summary Get organizations with access to a campaign
 */
export const getCampaignAccessByCampaign = (
    campaignId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignAccessByCampaignDto>(
      {url: `/campaign-access/by-campaign/${campaignId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampaignAccessByCampaignQueryKey = (campaignId: string,) => {
    return [
    `/campaign-access/by-campaign/${campaignId}`
    ] as const;
    }

    
export const getGetCampaignAccessByCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignAccessByCampaign>>, TError = ErrorType<void>>(campaignId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignAccessByCampaign>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignAccessByCampaignQueryKey(campaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignAccessByCampaign>>> = ({ signal }) => getCampaignAccessByCampaign(campaignId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(campaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignAccessByCampaign>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCampaignAccessByCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignAccessByCampaign>>>
export type GetCampaignAccessByCampaignQueryError = ErrorType<void>


/**
 * @summary Get organizations with access to a campaign
 */

export function useGetCampaignAccessByCampaign<TData = Awaited<ReturnType<typeof getCampaignAccessByCampaign>>, TError = ErrorType<void>>(
 campaignId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignAccessByCampaign>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCampaignAccessByCampaignQueryOptions(campaignId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Set which organizations have access to a campaign
 * @summary Update campaign access
 */
export const updateCampaignAccess = (
    campaignId: string,
    updateCampaignAccessDto: BodyType<UpdateCampaignAccessDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignAccessByCampaignDto>(
      {url: `/campaign-access/by-campaign/${campaignId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCampaignAccessDto, signal
    },
      options);
    }
  


export const getUpdateCampaignAccessMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignAccess>>, TError,{campaignId: string;data: BodyType<UpdateCampaignAccessDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampaignAccess>>, TError,{campaignId: string;data: BodyType<UpdateCampaignAccessDto>}, TContext> => {

const mutationKey = ['updateCampaignAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampaignAccess>>, {campaignId: string;data: BodyType<UpdateCampaignAccessDto>}> = (props) => {
          const {campaignId,data} = props ?? {};

          return  updateCampaignAccess(campaignId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampaignAccessMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaignAccess>>>
    export type UpdateCampaignAccessMutationBody = BodyType<UpdateCampaignAccessDto>
    export type UpdateCampaignAccessMutationError = ErrorType<void>

    /**
 * @summary Update campaign access
 */
export const useUpdateCampaignAccess = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignAccess>>, TError,{campaignId: string;data: BodyType<UpdateCampaignAccessDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCampaignAccess>>,
        TError,
        {campaignId: string;data: BodyType<UpdateCampaignAccessDto>},
        TContext
      > => {
      return useMutation(getUpdateCampaignAccessMutationOptions(options));
    }
    
/**
 * Remove a campaign's access from all organizations (useful when deleting a campaign)
 * @summary Remove campaign access from all organizations
 */
export const removeCampaignAccess = (
    campaignId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CampaignAccessRemovedResponseDto>(
      {url: `/campaign-access/by-campaign/${campaignId}`, method: 'DELETE', signal
    },
      options);
    }
  


export const getRemoveCampaignAccessMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAccess>>, TError,{campaignId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAccess>>, TError,{campaignId: string}, TContext> => {

const mutationKey = ['removeCampaignAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCampaignAccess>>, {campaignId: string}> = (props) => {
          const {campaignId} = props ?? {};

          return  removeCampaignAccess(campaignId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveCampaignAccessMutationResult = NonNullable<Awaited<ReturnType<typeof removeCampaignAccess>>>
    
    export type RemoveCampaignAccessMutationError = ErrorType<void>

    /**
 * @summary Remove campaign access from all organizations
 */
export const useRemoveCampaignAccess = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAccess>>, TError,{campaignId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeCampaignAccess>>,
        TError,
        {campaignId: string},
        TContext
      > => {
      return useMutation(getRemoveCampaignAccessMutationOptions(options));
    }
    
/**
 * Retrieve all campaigns that a specific organization has access to
 * @summary Get campaigns an organization has access to
 */
export const getCampaignsForOrganization = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationCampaignsDto>(
      {url: `/campaign-access/by-organization/${organizationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCampaignsForOrganizationQueryKey = (organizationId: string,) => {
    return [
    `/campaign-access/by-organization/${organizationId}`
    ] as const;
    }

    
export const getGetCampaignsForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignsForOrganization>>, TError = ErrorType<void>>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignsForOrganization>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignsForOrganizationQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsForOrganization>>> = ({ signal }) => getCampaignsForOrganization(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignsForOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCampaignsForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignsForOrganization>>>
export type GetCampaignsForOrganizationQueryError = ErrorType<void>


/**
 * @summary Get campaigns an organization has access to
 */

export function useGetCampaignsForOrganization<TData = Awaited<ReturnType<typeof getCampaignsForOrganization>>, TError = ErrorType<void>>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCampaignsForOrganization>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCampaignsForOrganizationQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns the current IP gather campaign, visit lookback window, and install/purchase suppression lookback window settings
 * @summary Get advanced targeting settings
 */
export const getAdvancedTargetingSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdvancedTargetingSettingsDto>(
      {url: `/advanced-targeting/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdvancedTargetingSettingsQueryKey = () => {
    return [
    `/advanced-targeting/settings`
    ] as const;
    }

    
export const getGetAdvancedTargetingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAdvancedTargetingSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingSettings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdvancedTargetingSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdvancedTargetingSettings>>> = ({ signal }) => getAdvancedTargetingSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdvancedTargetingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdvancedTargetingSettings>>>
export type GetAdvancedTargetingSettingsQueryError = ErrorType<void>


/**
 * @summary Get advanced targeting settings
 */

export function useGetAdvancedTargetingSettings<TData = Awaited<ReturnType<typeof getAdvancedTargetingSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingSettings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdvancedTargetingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Partially updates the IP gather campaign, visit lookback window, and/or install/purchase suppression lookback window settings
 * @summary Update advanced targeting settings
 */
export const updateAdvancedTargetingSettings = (
    updateAdvancedTargetingSettingsDto: BodyType<UpdateAdvancedTargetingSettingsDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdvancedTargetingSettingsDto>(
      {url: `/advanced-targeting/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAdvancedTargetingSettingsDto, signal
    },
      options);
    }
  


export const getUpdateAdvancedTargetingSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>, TError,{data: BodyType<UpdateAdvancedTargetingSettingsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>, TError,{data: BodyType<UpdateAdvancedTargetingSettingsDto>}, TContext> => {

const mutationKey = ['updateAdvancedTargetingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>, {data: BodyType<UpdateAdvancedTargetingSettingsDto>}> = (props) => {
          const {data} = props ?? {};

          return  updateAdvancedTargetingSettings(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdvancedTargetingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>>
    export type UpdateAdvancedTargetingSettingsMutationBody = BodyType<UpdateAdvancedTargetingSettingsDto>
    export type UpdateAdvancedTargetingSettingsMutationError = ErrorType<void>

    /**
 * @summary Update advanced targeting settings
 */
export const useUpdateAdvancedTargetingSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>, TError,{data: BodyType<UpdateAdvancedTargetingSettingsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdvancedTargetingSettings>>,
        TError,
        {data: BodyType<UpdateAdvancedTargetingSettingsDto>},
        TContext
      > => {
      return useMutation(getUpdateAdvancedTargetingSettingsMutationOptions(options));
    }
    
/**
 * Starts the chosen audience job in the background using the saved settings and returns immediately. The run appears in the logs with status 'running' and is finalized when it completes. Rejected with 409 if a run of that job is already in progress.
 * @summary Manually trigger an audience gather run
 */
export const triggerAdvancedTargetingRun = (
    params?: TriggerAdvancedTargetingRunParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdvancedTargetingRunTriggeredDto>(
      {url: `/advanced-targeting/run`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getTriggerAdvancedTargetingRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>, TError,{params?: TriggerAdvancedTargetingRunParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>, TError,{params?: TriggerAdvancedTargetingRunParams}, TContext> => {

const mutationKey = ['triggerAdvancedTargetingRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>, {params?: TriggerAdvancedTargetingRunParams}> = (props) => {
          const {params} = props ?? {};

          return  triggerAdvancedTargetingRun(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerAdvancedTargetingRunMutationResult = NonNullable<Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>>
    
    export type TriggerAdvancedTargetingRunMutationError = ErrorType<void>

    /**
 * @summary Manually trigger an audience gather run
 */
export const useTriggerAdvancedTargetingRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>, TError,{params?: TriggerAdvancedTargetingRunParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerAdvancedTargetingRun>>,
        TError,
        {params?: TriggerAdvancedTargetingRunParams},
        TContext
      > => {
      return useMutation(getTriggerAdvancedTargetingRunMutationOptions(options));
    }
    
/**
 * Returns recent IP gather job runs with aggregate counts, newest first (read-only)
 * @summary Get advanced targeting run logs
 */
export const getAdvancedTargetingLogs = (
    params?: GetAdvancedTargetingLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdvancedTargetingRunsResponseDto>(
      {url: `/advanced-targeting/logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAdvancedTargetingLogsQueryKey = (params?: GetAdvancedTargetingLogsParams,) => {
    return [
    `/advanced-targeting/logs`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAdvancedTargetingLogsQueryOptions = <TData = Awaited<ReturnType<typeof getAdvancedTargetingLogs>>, TError = ErrorType<void>>(params?: GetAdvancedTargetingLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdvancedTargetingLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdvancedTargetingLogs>>> = ({ signal }) => getAdvancedTargetingLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdvancedTargetingLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdvancedTargetingLogs>>>
export type GetAdvancedTargetingLogsQueryError = ErrorType<void>


/**
 * @summary Get advanced targeting run logs
 */

export function useGetAdvancedTargetingLogs<TData = Awaited<ReturnType<typeof getAdvancedTargetingLogs>>, TError = ErrorType<void>>(
 params?: GetAdvancedTargetingLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdvancedTargetingLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdvancedTargetingLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Upload a single conversion file (.xlsx) for a campaign. id_campaign is REQUIRED. Returns 202 with a batchId immediately; ingestion + attribution refresh run in the background.
 * @summary Upload a conversion file
 */
export const createConversionUpload = (
    conversionUploadRequestDto: BodyType<ConversionUploadRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`id_campaign`, conversionUploadRequestDto.id_campaign);
formData.append(`file`, conversionUploadRequestDto.file);

      return customInstance<UploadAcceptedResponseDto>(
      {url: `/conversion-uploads`, method: 'POST',
       data: formData, signal
    },
      options);
    }
  


export const getCreateConversionUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversionUpload>>, TError,{data: BodyType<ConversionUploadRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversionUpload>>, TError,{data: BodyType<ConversionUploadRequestDto>}, TContext> => {

const mutationKey = ['createConversionUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversionUpload>>, {data: BodyType<ConversionUploadRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  createConversionUpload(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConversionUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createConversionUpload>>>
    export type CreateConversionUploadMutationBody = BodyType<ConversionUploadRequestDto>
    export type CreateConversionUploadMutationError = ErrorType<void>

    /**
 * @summary Upload a conversion file
 */
export const useCreateConversionUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversionUpload>>, TError,{data: BodyType<ConversionUploadRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConversionUpload>>,
        TError,
        {data: BodyType<ConversionUploadRequestDto>},
        TContext
      > => {
      return useMutation(getCreateConversionUploadMutationOptions(options));
    }
    
/**
 * Returns an .xlsx template (header row + example) for the campaign's handler.
 * @summary Download the upload template for a campaign
 */
export const getConversionUploadTemplate = (
    params: GetConversionUploadTemplateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/conversion-uploads/template`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetConversionUploadTemplateQueryKey = (params?: GetConversionUploadTemplateParams,) => {
    return [
    `/conversion-uploads/template`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetConversionUploadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getConversionUploadTemplate>>, TError = ErrorType<void>>(params: GetConversionUploadTemplateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadTemplate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversionUploadTemplateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversionUploadTemplate>>> = ({ signal }) => getConversionUploadTemplate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversionUploadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getConversionUploadTemplate>>>
export type GetConversionUploadTemplateQueryError = ErrorType<void>


/**
 * @summary Download the upload template for a campaign
 */

export function useGetConversionUploadTemplate<TData = Awaited<ReturnType<typeof getConversionUploadTemplate>>, TError = ErrorType<void>>(
 params: GetConversionUploadTemplateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadTemplate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversionUploadTemplateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Dates from the first-ever verified install to today that have zero verified-install events for the campaign. Dates before the first install are never flagged.
 * @summary Days with no verified install
 */
export const getConversionUploadMissingDays = (
    params: GetConversionUploadMissingDaysParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MissingVerifiedInstallDaysResponseDto>(
      {url: `/conversion-uploads/missing-days`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetConversionUploadMissingDaysQueryKey = (params?: GetConversionUploadMissingDaysParams,) => {
    return [
    `/conversion-uploads/missing-days`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetConversionUploadMissingDaysQueryOptions = <TData = Awaited<ReturnType<typeof getConversionUploadMissingDays>>, TError = ErrorType<void>>(params: GetConversionUploadMissingDaysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadMissingDays>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversionUploadMissingDaysQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversionUploadMissingDays>>> = ({ signal }) => getConversionUploadMissingDays(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadMissingDays>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversionUploadMissingDaysQueryResult = NonNullable<Awaited<ReturnType<typeof getConversionUploadMissingDays>>>
export type GetConversionUploadMissingDaysQueryError = ErrorType<void>


/**
 * @summary Days with no verified install
 */

export function useGetConversionUploadMissingDays<TData = Awaited<ReturnType<typeof getConversionUploadMissingDays>>, TError = ErrorType<void>>(
 params: GetConversionUploadMissingDaysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadMissingDays>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversionUploadMissingDaysQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List upload batches, optionally filtered by campaign.
 * @summary List conversion upload batches
 */
export const listConversionUploadBatches = (
    params?: ListConversionUploadBatchesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BatchListResponseDto>(
      {url: `/conversion-uploads/batches`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListConversionUploadBatchesQueryKey = (params?: ListConversionUploadBatchesParams,) => {
    return [
    `/conversion-uploads/batches`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListConversionUploadBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listConversionUploadBatches>>, TError = ErrorType<unknown>>(params?: ListConversionUploadBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversionUploadBatches>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversionUploadBatchesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversionUploadBatches>>> = ({ signal }) => listConversionUploadBatches(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversionUploadBatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversionUploadBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listConversionUploadBatches>>>
export type ListConversionUploadBatchesQueryError = ErrorType<unknown>


/**
 * @summary List conversion upload batches
 */

export function useListConversionUploadBatches<TData = Awaited<ReturnType<typeof listConversionUploadBatches>>, TError = ErrorType<unknown>>(
 params?: ListConversionUploadBatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversionUploadBatches>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConversionUploadBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a batch with its sparse audit rows and reconciliation counts.
 * @summary Get a conversion upload batch
 */
export const getConversionUploadBatch = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BatchDetailResponseDto>(
      {url: `/conversion-uploads/batches/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetConversionUploadBatchQueryKey = (id: string,) => {
    return [
    `/conversion-uploads/batches/${id}`
    ] as const;
    }

    
export const getGetConversionUploadBatchQueryOptions = <TData = Awaited<ReturnType<typeof getConversionUploadBatch>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadBatch>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversionUploadBatchQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversionUploadBatch>>> = ({ signal }) => getConversionUploadBatch(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadBatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversionUploadBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getConversionUploadBatch>>>
export type GetConversionUploadBatchQueryError = ErrorType<void>


/**
 * @summary Get a conversion upload batch
 */

export function useGetConversionUploadBatch<TData = Awaited<ReturnType<typeof getConversionUploadBatch>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversionUploadBatch>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversionUploadBatchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Modes and why any are unavailable, the metric registry with stable colours and units, the default metric selection per mode, the publisher breakdown dimension and its campaign label, and the campaign payout. The frontend renders from this and computes nothing itself.
 * @summary Everything the dashboard is allowed to show
 */
export const getDashboardCatalogue = (
    params: GetDashboardCatalogueParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DashboardCatalogueDto>(
      {url: `/dashboard/catalogue`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDashboardCatalogueQueryKey = (params?: GetDashboardCatalogueParams,) => {
    return [
    `/dashboard/catalogue`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDashboardCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardCatalogue>>, TError = ErrorType<void>>(params: GetDashboardCatalogueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardCatalogue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardCatalogueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardCatalogue>>> = ({ signal }) => getDashboardCatalogue(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardCatalogue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardCatalogue>>>
export type GetDashboardCatalogueQueryError = ErrorType<void>


/**
 * @summary Everything the dashboard is allowed to show
 */

export function useGetDashboardCatalogue<TData = Awaited<ReturnType<typeof getDashboardCatalogue>>, TError = ErrorType<void>>(
 params: GetDashboardCatalogueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardCatalogue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardCatalogueQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Basis-aware buckets with CPM, RPM, profit and conversions, the per-bucket top profit driver for the tooltip, the series list with colours, and the axis assignment. Returns the grain it actually used, which may differ from "auto".
 * @summary Chart buckets for the range, at the resolved grain
 */
export const getDashboardTimeseries = (
    params: GetDashboardTimeseriesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DashboardTimeseriesDto>(
      {url: `/dashboard/timeseries`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDashboardTimeseriesQueryKey = (params?: GetDashboardTimeseriesParams,) => {
    return [
    `/dashboard/timeseries`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDashboardTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardTimeseries>>, TError = ErrorType<void>>(params: GetDashboardTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardTimeseriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardTimeseries>>> = ({ signal }) => getDashboardTimeseries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardTimeseries>>>
export type GetDashboardTimeseriesQueryError = ErrorType<void>


/**
 * @summary Chart buckets for the range, at the resolved grain
 */

export function useGetDashboardTimeseries<TData = Awaited<ReturnType<typeof getDashboardTimeseries>>, TError = ErrorType<void>>(
 params: GetDashboardTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardTimeseries>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardTimeseriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * One scan answering both panels, because they cover the same window, baseline and dimension. KPIs: Avg CPM, Avg RPM, Edge per 1K, Total Profit, Profitable Days and Cost, each with its accent and — when a baseline is supplied — its delta. Breakdown: one row per publisher, with the profit change and the CPM/RPM/Edge contributions split into rate and mix effects, which sum exactly to the overall change. Values are null, never zero, where the basis has no data.
 * @summary KPI row and publisher breakdown for the selected window
 */
export const getDashboardWindow = (
    params: GetDashboardWindowParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DashboardWindowDataDto>(
      {url: `/dashboard/window`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDashboardWindowQueryKey = (params?: GetDashboardWindowParams,) => {
    return [
    `/dashboard/window`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDashboardWindowQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardWindow>>, TError = ErrorType<void>>(params: GetDashboardWindowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardWindow>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardWindowQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardWindow>>> = ({ signal }) => getDashboardWindow(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardWindow>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardWindowQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardWindow>>>
export type GetDashboardWindowQueryError = ErrorType<void>


/**
 * @summary KPI row and publisher breakdown for the selected window
 */

export function useGetDashboardWindow<TData = Awaited<ReturnType<typeof getDashboardWindow>>, TError = ErrorType<void>>(
 params: GetDashboardWindowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardWindow>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardWindowQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Both windows run from midnight UTC to the same wall-clock instant, and each counts only the conversions that had arrived by its own cutoff — so every impression on both sides has had exactly the same time to convert. Without that cap yesterday carries a full extra day of attribution maturity and today always looks worse. Returns each metric with its percentage change and whether the movement is good or bad. Basis-independent: nothing here depends on how a conversion is valued, so the figures are identical whichever basis the page is on.
 * @summary Today so far versus the same slice of yesterday
 */
export const getDashboardPacing = (
    params: GetDashboardPacingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DashboardPacingDto>(
      {url: `/dashboard/pacing`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDashboardPacingQueryKey = (params?: GetDashboardPacingParams,) => {
    return [
    `/dashboard/pacing`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetDashboardPacingQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardPacing>>, TError = ErrorType<void>>(params: GetDashboardPacingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardPacing>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardPacingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPacing>>> = ({ signal }) => getDashboardPacing(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardPacing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardPacingQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardPacing>>>
export type GetDashboardPacingQueryError = ErrorType<void>


/**
 * @summary Today so far versus the same slice of yesterday
 */

export function useGetDashboardPacing<TData = Awaited<ReturnType<typeof getDashboardPacing>>, TError = ErrorType<void>>(
 params: GetDashboardPacingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardPacing>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardPacingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * The dimension menu is built from the campaign's own configured dimensions merged over a universal set, so a c-slot carries whatever label the team gave it. Each entry reports its source tier — coarse and detailed read a rollup and are fast, raw scans pixels and is not — and whether the Predicted basis is available at that grain.
 * @summary Dimensions, presets and views Explorer may offer for a campaign
 */
export const getExplorerCatalogue = (
    params: GetExplorerCatalogueParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExplorerCatalogueDto>(
      {url: `/dashboard/explorer/catalogue`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetExplorerCatalogueQueryKey = (params?: GetExplorerCatalogueParams,) => {
    return [
    `/dashboard/explorer/catalogue`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetExplorerCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof getExplorerCatalogue>>, TError = ErrorType<void>>(params: GetExplorerCatalogueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerCatalogue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExplorerCatalogueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExplorerCatalogue>>> = ({ signal }) => getExplorerCatalogue(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExplorerCatalogue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExplorerCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof getExplorerCatalogue>>>
export type GetExplorerCatalogueQueryError = ErrorType<void>


/**
 * @summary Dimensions, presets and views Explorer may offer for a campaign
 */

export function useGetExplorerCatalogue<TData = Awaited<ReturnType<typeof getExplorerCatalogue>>, TError = ErrorType<void>>(
 params: GetExplorerCatalogueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerCatalogue>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExplorerCatalogueQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * One row per slice with cost, CPM, RPM, edge, profit and the verification figures, plus — when neither dimension is the publisher axis — how the result distributes across publishers: coverage, profitable share, profit concentration, consistency, and a plain-language reading of them. Bounded by the minimum-impressions floor rather than by truncation; when the display cap does bite, `truncated` says so.
 * @summary Slices for one or two dimensions, with publisher context
 */
export const getExplorer = (
    params: GetExplorerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExplorerResultDto>(
      {url: `/dashboard/explorer`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetExplorerQueryKey = (params?: GetExplorerParams,) => {
    return [
    `/dashboard/explorer`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetExplorerQueryOptions = <TData = Awaited<ReturnType<typeof getExplorer>>, TError = ErrorType<void>>(params: GetExplorerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExplorerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExplorer>>> = ({ signal }) => getExplorer(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExplorer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExplorerQueryResult = NonNullable<Awaited<ReturnType<typeof getExplorer>>>
export type GetExplorerQueryError = ErrorType<void>


/**
 * @summary Slices for one or two dimensions, with publisher context
 */

export function useGetExplorer<TData = Awaited<ReturnType<typeof getExplorer>>, TError = ErrorType<void>>(
 params: GetExplorerParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorer>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExplorerQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Busiest first, capped, for the scope selects. Reads whichever rollup carries the dimension.
 * @summary Distinct values of one dimension over the window
 */
export const getExplorerValues = (
    params: GetExplorerValuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/dashboard/explorer/values`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetExplorerValuesQueryKey = (params?: GetExplorerValuesParams,) => {
    return [
    `/dashboard/explorer/values`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetExplorerValuesQueryOptions = <TData = Awaited<ReturnType<typeof getExplorerValues>>, TError = ErrorType<void>>(params: GetExplorerValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExplorerValuesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExplorerValues>>> = ({ signal }) => getExplorerValues(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExplorerValues>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExplorerValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getExplorerValues>>>
export type GetExplorerValuesQueryError = ErrorType<void>


/**
 * @summary Distinct values of one dimension over the window
 */

export function useGetExplorerValues<TData = Awaited<ReturnType<typeof getExplorerValues>>, TError = ErrorType<void>>(
 params: GetExplorerValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExplorerValuesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * A second request on purpose — these three splits are a different grain from the table and would triple the main scan for a panel most rows never show. The country split is omitted when Country is already a grouping dimension.
 * @summary One slice opened: publisher split, country split and daily trend
 */
export const getExplorerRow = (
    params: GetExplorerRowParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ExplorerRowDetailDto>(
      {url: `/dashboard/explorer/row`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetExplorerRowQueryKey = (params?: GetExplorerRowParams,) => {
    return [
    `/dashboard/explorer/row`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetExplorerRowQueryOptions = <TData = Awaited<ReturnType<typeof getExplorerRow>>, TError = ErrorType<void>>(params: GetExplorerRowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerRow>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExplorerRowQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExplorerRow>>> = ({ signal }) => getExplorerRow(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExplorerRow>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExplorerRowQueryResult = NonNullable<Awaited<ReturnType<typeof getExplorerRow>>>
export type GetExplorerRowQueryError = ErrorType<void>


/**
 * @summary One slice opened: publisher split, country split and daily trend
 */

export function useGetExplorerRow<TData = Awaited<ReturnType<typeof getExplorerRow>>, TError = ErrorType<void>>(
 params: GetExplorerRowParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExplorerRow>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExplorerRowQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * The roster over the campaign's configured publisher axis. Every row carries the same figures Explorer produces plus a day-by-day series for the inline drilldown, and a share of campaign cost. No impression floor: a roster that hides its small publishers is not a roster. TOTAL is summed from numerators and denominators, never averaged from the rows.
 * @summary One row per publisher, each with its daily history
 */
export const getPublisherRoster = (
    params: GetPublisherRosterParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublisherRosterDto>(
      {url: `/dashboard/publishers`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPublisherRosterQueryKey = (params?: GetPublisherRosterParams,) => {
    return [
    `/dashboard/publishers`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetPublisherRosterQueryOptions = <TData = Awaited<ReturnType<typeof getPublisherRoster>>, TError = ErrorType<void>>(params: GetPublisherRosterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublisherRoster>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublisherRosterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublisherRoster>>> = ({ signal }) => getPublisherRoster(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublisherRoster>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublisherRosterQueryResult = NonNullable<Awaited<ReturnType<typeof getPublisherRoster>>>
export type GetPublisherRosterQueryError = ErrorType<void>


/**
 * @summary One row per publisher, each with its daily history
 */

export function useGetPublisherRoster<TData = Awaited<ReturnType<typeof getPublisherRoster>>, TError = ErrorType<void>>(
 params: GetPublisherRosterParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublisherRoster>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublisherRosterQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Recent tiering summaries and publication outcomes
 */
export const getTieringAuditRuns = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/audit/runs`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTieringAuditRunsQueryKey = () => {
    return [
    `/crossroads-tiering/audit/runs`
    ] as const;
    }

    
export const getGetTieringAuditRunsQueryOptions = <TData = Awaited<ReturnType<typeof getTieringAuditRuns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditRuns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTieringAuditRunsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTieringAuditRuns>>> = ({ signal }) => getTieringAuditRuns(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTieringAuditRunsQueryResult = NonNullable<Awaited<ReturnType<typeof getTieringAuditRuns>>>
export type GetTieringAuditRunsQueryError = ErrorType<unknown>


/**
 * @summary Recent tiering summaries and publication outcomes
 */

export function useGetTieringAuditRuns<TData = Awaited<ReturnType<typeof getTieringAuditRuns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditRuns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTieringAuditRunsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Search saved decisions and tier movements
 */
export const getTieringAuditDecisions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/audit/runs/${id}/decisions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTieringAuditDecisionsQueryKey = (id: string,) => {
    return [
    `/crossroads-tiering/audit/runs/${id}/decisions`
    ] as const;
    }

    
export const getGetTieringAuditDecisionsQueryOptions = <TData = Awaited<ReturnType<typeof getTieringAuditDecisions>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditDecisions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTieringAuditDecisionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTieringAuditDecisions>>> = ({ signal }) => getTieringAuditDecisions(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditDecisions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTieringAuditDecisionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTieringAuditDecisions>>>
export type GetTieringAuditDecisionsQueryError = ErrorType<unknown>


/**
 * @summary Search saved decisions and tier movements
 */

export function useGetTieringAuditDecisions<TData = Awaited<ReturnType<typeof getTieringAuditDecisions>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringAuditDecisions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTieringAuditDecisionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Shared tiering review queue
 */
export const getTieringActions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/audit/actions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTieringActionsQueryKey = () => {
    return [
    `/crossroads-tiering/audit/actions`
    ] as const;
    }

    
export const getGetTieringActionsQueryOptions = <TData = Awaited<ReturnType<typeof getTieringActions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringActions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTieringActionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTieringActions>>> = ({ signal }) => getTieringActions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTieringActions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTieringActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTieringActions>>>
export type GetTieringActionsQueryError = ErrorType<unknown>


/**
 * @summary Shared tiering review queue
 */

export function useGetTieringActions<TData = Awaited<ReturnType<typeof getTieringActions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTieringActions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTieringActionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Set action status without changing classification
 */
export const updateTieringAction = (
    kind: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/audit/actions/${kind}`, method: 'PUT', signal
    },
      options);
    }
  


export const getUpdateTieringActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTieringAction>>, TError,{kind: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTieringAction>>, TError,{kind: string}, TContext> => {

const mutationKey = ['updateTieringAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTieringAction>>, {kind: string}> = (props) => {
          const {kind} = props ?? {};

          return  updateTieringAction(kind,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTieringActionMutationResult = NonNullable<Awaited<ReturnType<typeof updateTieringAction>>>
    
    export type UpdateTieringActionMutationError = ErrorType<unknown>

    /**
 * @summary Set action status without changing classification
 */
export const useUpdateTieringAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTieringAction>>, TError,{kind: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTieringAction>>,
        TError,
        {kind: string},
        TContext
      > => {
      return useMutation(getUpdateTieringActionMutationOptions(options));
    }
    
/**
 * @summary Last manual GraphQL schema check and freshness
 */
export const getCrossroadsSchemaMonitor = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/monitor`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCrossroadsSchemaMonitorQueryKey = () => {
    return [
    `/crossroads-tiering/monitor`
    ] as const;
    }

    
export const getGetCrossroadsSchemaMonitorQueryOptions = <TData = Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrossroadsSchemaMonitorQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>> = ({ signal }) => getCrossroadsSchemaMonitor(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrossroadsSchemaMonitorQueryResult = NonNullable<Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>>
export type GetCrossroadsSchemaMonitorQueryError = ErrorType<unknown>


/**
 * @summary Last manual GraphQL schema check and freshness
 */

export function useGetCrossroadsSchemaMonitor<TData = Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsSchemaMonitor>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrossroadsSchemaMonitorQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Validate operations against live schemas without executing mutations
 */
export const runCrossroadsSchemaMonitor = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/monitor`, method: 'POST', signal
    },
      options);
    }
  


export const getRunCrossroadsSchemaMonitorMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>, TError,void, TContext> => {

const mutationKey = ['runCrossroadsSchemaMonitor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>, void> = () => {
          

          return  runCrossroadsSchemaMonitor(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RunCrossroadsSchemaMonitorMutationResult = NonNullable<Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>>
    
    export type RunCrossroadsSchemaMonitorMutationError = ErrorType<void>

    /**
 * @summary Validate operations against live schemas without executing mutations
 */
export const useRunCrossroadsSchemaMonitor = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runCrossroadsSchemaMonitor>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRunCrossroadsSchemaMonitorMutationOptions(options));
    }
    
/**
 * Confidence multiplier, data floor, lookback, value cap, payout override and the seat table. Seat credentials are read from the environment and are never returned.
 * @summary Get Crossroads tiering settings
 */
export const getCrossroadsTieringSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCrossroadsTieringSettingsQueryKey = () => {
    return [
    `/crossroads-tiering/settings`
    ] as const;
    }

    
export const getGetCrossroadsTieringSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCrossroadsTieringSettings>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringSettings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrossroadsTieringSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrossroadsTieringSettings>>> = ({ signal }) => getCrossroadsTieringSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrossroadsTieringSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCrossroadsTieringSettings>>>
export type GetCrossroadsTieringSettingsQueryError = ErrorType<void>


/**
 * @summary Get Crossroads tiering settings
 */

export function useGetCrossroadsTieringSettings<TData = Awaited<ReturnType<typeof getCrossroadsTieringSettings>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringSettings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrossroadsTieringSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Partial update. Only known setting keys are accepted.
 * @summary Update Crossroads tiering settings
 */
export const updateCrossroadsTieringSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/settings`, method: 'PUT', signal
    },
      options);
    }
  


export const getUpdateCrossroadsTieringSettingsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>, TError,void, TContext> => {

const mutationKey = ['updateCrossroadsTieringSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>, void> = () => {
          

          return  updateCrossroadsTieringSettings(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCrossroadsTieringSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>>
    
    export type UpdateCrossroadsTieringSettingsMutationError = ErrorType<void>

    /**
 * @summary Update Crossroads tiering settings
 */
export const useUpdateCrossroadsTieringSettings = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCrossroadsTieringSettings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUpdateCrossroadsTieringSettingsMutationOptions(options));
    }
    
/**
 * Starts a run in the background and returns immediately. A dry run classifies every cohort and logs what would be published without writing to Crossroads or recording anything.
 * @summary Manually trigger a tiering run
 */
export const triggerCrossroadsTieringRun = (
    params?: TriggerCrossroadsTieringRunParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/run`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getTriggerCrossroadsTieringRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>, TError,{params?: TriggerCrossroadsTieringRunParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>, TError,{params?: TriggerCrossroadsTieringRunParams}, TContext> => {

const mutationKey = ['triggerCrossroadsTieringRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>, {params?: TriggerCrossroadsTieringRunParams}> = (props) => {
          const {params} = props ?? {};

          return  triggerCrossroadsTieringRun(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerCrossroadsTieringRunMutationResult = NonNullable<Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>>
    
    export type TriggerCrossroadsTieringRunMutationError = ErrorType<void>

    /**
 * @summary Manually trigger a tiering run
 */
export const useTriggerCrossroadsTieringRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>, TError,{params?: TriggerCrossroadsTieringRunParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerCrossroadsTieringRun>>,
        TError,
        {params?: TriggerCrossroadsTieringRunParams},
        TContext
      > => {
      return useMutation(getTriggerCrossroadsTieringRunMutationOptions(options));
    }
    
/**
 * Per seat, removes only Remote Automation rows named [EXP|HLD|BST - XX] for a US state whose id is in the tiering registry under that tier and state; each is detached from its tags, then removed. Dry run unless dryRun=false. A real run needs the dry run's confirmToken and deletes nothing unless the rows it finds are exactly the ones that token covers; no seat may retire more than 153.
 * @summary Remove the state-era tier rows from Crossroads
 */
export const retireCrossroadsStateRows = (
    params?: RetireCrossroadsStateRowsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/retire-state-rows`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getRetireCrossroadsStateRowsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireCrossroadsStateRows>>, TError,{params?: RetireCrossroadsStateRowsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retireCrossroadsStateRows>>, TError,{params?: RetireCrossroadsStateRowsParams}, TContext> => {

const mutationKey = ['retireCrossroadsStateRows'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retireCrossroadsStateRows>>, {params?: RetireCrossroadsStateRowsParams}> = (props) => {
          const {params} = props ?? {};

          return  retireCrossroadsStateRows(params,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RetireCrossroadsStateRowsMutationResult = NonNullable<Awaited<ReturnType<typeof retireCrossroadsStateRows>>>
    
    export type RetireCrossroadsStateRowsMutationError = ErrorType<void>

    /**
 * @summary Remove the state-era tier rows from Crossroads
 */
export const useRetireCrossroadsStateRows = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireCrossroadsStateRows>>, TError,{params?: RetireCrossroadsStateRowsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retireCrossroadsStateRows>>,
        TError,
        {params?: RetireCrossroadsStateRowsParams},
        TContext
      > => {
      return useMutation(getRetireCrossroadsStateRowsMutationOptions(options));
    }
    
/**
 * Recent runs with tier counts and publish outcomes, newest first (read-only).
 * @summary Get tiering run logs
 */
export const getCrossroadsTieringLogs = (
    params?: GetCrossroadsTieringLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/crossroads-tiering/logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCrossroadsTieringLogsQueryKey = (params?: GetCrossroadsTieringLogsParams,) => {
    return [
    `/crossroads-tiering/logs`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCrossroadsTieringLogsQueryOptions = <TData = Awaited<ReturnType<typeof getCrossroadsTieringLogs>>, TError = ErrorType<void>>(params?: GetCrossroadsTieringLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCrossroadsTieringLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrossroadsTieringLogs>>> = ({ signal }) => getCrossroadsTieringLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCrossroadsTieringLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getCrossroadsTieringLogs>>>
export type GetCrossroadsTieringLogsQueryError = ErrorType<void>


/**
 * @summary Get tiering run logs
 */

export function useGetCrossroadsTieringLogs<TData = Awaited<ReturnType<typeof getCrossroadsTieringLogs>>, TError = ErrorType<void>>(
 params?: GetCrossroadsTieringLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCrossroadsTieringLogs>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCrossroadsTieringLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Confirms the key and that the API reads through its read-only, time-capped connection.
 * @summary Check an API key
 */
export const apiPing = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PingResponseDto>(
      {url: `/api/v1/ping`, method: 'GET', signal
    },
      options);
    }
  



export const getApiPingQueryKey = () => {
    return [
    `/api/v1/ping`
    ] as const;
    }

    
export const getApiPingQueryOptions = <TData = Awaited<ReturnType<typeof apiPing>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPing>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPing>>> = ({ signal }) => apiPing(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiPing>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiPingQueryResult = NonNullable<Awaited<ReturnType<typeof apiPing>>>
export type ApiPingQueryError = ErrorType<void>


/**
 * @summary Check an API key
 */

export function useApiPing<TData = Awaited<ReturnType<typeof apiPing>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPing>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiPingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Every campaign; a key sees all of them.
 * @summary Campaigns
 */
export const apiListCampaigns = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiCampaignsResponseDto>(
      {url: `/api/v1/campaigns`, method: 'GET', signal
    },
      options);
    }
  



export const getApiListCampaignsQueryKey = () => {
    return [
    `/api/v1/campaigns`
    ] as const;
    }

    
export const getApiListCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof apiListCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiListCampaigns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiListCampaignsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiListCampaigns>>> = ({ signal }) => apiListCampaigns(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiListCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiListCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof apiListCampaigns>>>
export type ApiListCampaignsQueryError = ErrorType<unknown>


/**
 * @summary Campaigns
 */

export function useApiListCampaigns<TData = Awaited<ReturnType<typeof apiListCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiListCampaigns>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiListCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Dimensions, metrics, the campaign's events with their attribution windows and response columns, calculated metrics, and notes on reading the numbers.
 * @summary What a report can ask for
 */
export const apiCatalog = (
    params: ApiCatalogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiCatalogResponseDto>(
      {url: `/api/v1/catalog`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiCatalogQueryKey = (params?: ApiCatalogParams,) => {
    return [
    `/api/v1/catalog`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getApiCatalogQueryOptions = <TData = Awaited<ReturnType<typeof apiCatalog>>, TError = ErrorType<unknown>>(params: ApiCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiCatalog>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiCatalogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCatalog>>> = ({ signal }) => apiCatalog(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof apiCatalog>>>
export type ApiCatalogQueryError = ErrorType<unknown>


/**
 * @summary What a report can ask for
 */

export function useApiCatalog<TData = Awaited<ReturnType<typeof apiCatalog>>, TError = ErrorType<unknown>>(
 params: ApiCatalogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiCatalog>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiCatalogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * For building filters. At most 1000 values.
 * @summary Distinct values of a dimension
 */
export const apiDimensionValues = (
    params: ApiDimensionValuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/dimension-values`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiDimensionValuesQueryKey = (params?: ApiDimensionValuesParams,) => {
    return [
    `/api/v1/dimension-values`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getApiDimensionValuesQueryOptions = <TData = Awaited<ReturnType<typeof apiDimensionValues>>, TError = ErrorType<unknown>>(params: ApiDimensionValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDimensionValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDimensionValuesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDimensionValues>>> = ({ signal }) => apiDimensionValues(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDimensionValues>>, TError, TData> & { queryKey: QueryKey }
}

export type ApiDimensionValuesQueryResult = NonNullable<Awaited<ReturnType<typeof apiDimensionValues>>>
export type ApiDimensionValuesQueryError = ErrorType<unknown>


/**
 * @summary Distinct values of a dimension
 */

export function useApiDimensionValues<TData = Awaited<ReturnType<typeof apiDimensionValues>>, TError = ErrorType<unknown>>(
 params: ApiDimensionValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDimensionValues>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDimensionValuesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Same body as POST /api/v1/reports. Plans the exact statements the report would send and returns fast, bounded or blocked, with the reasons and ways to narrow a blocked one.
 * @summary Estimate a report without running it
 */
export const apiPlanReport = (
    reportingQueryRequestDto: BodyType<ReportingQueryRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiCostAssessmentDto>(
      {url: `/api/v1/reports/plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportingQueryRequestDto, signal
    },
      options);
    }
  


export const getApiPlanReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlanReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlanReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext> => {

const mutationKey = ['apiPlanReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlanReport>>, {data: BodyType<ReportingQueryRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPlanReport(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlanReportMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlanReport>>>
    export type ApiPlanReportMutationBody = BodyType<ReportingQueryRequestDto>
    export type ApiPlanReportMutationError = ErrorType<unknown>

    /**
 * @summary Estimate a report without running it
 */
export const useApiPlanReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlanReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof apiPlanReport>>,
        TError,
        {data: BodyType<ReportingQueryRequestDto>},
        TContext
      > => {
      return useMutation(getApiPlanReportMutationOptions(options));
    }
    
/**
 * Synchronous. The body is the same as the internal tool's POST /reporting/queries, with idCampaign required: one campaign, or several separated by commas. At most 10000 rows a page; page on with cursor. 60s limit per report, 2 at once per key.
 * @summary Run a report
 */
export const apiRunReport = (
    reportingQueryRequestDto: BodyType<ReportingQueryRequestDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiReportResponseDto>(
      {url: `/api/v1/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportingQueryRequestDto, signal
    },
      options);
    }
  


export const getApiRunReportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRunReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRunReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext> => {

const mutationKey = ['apiRunReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRunReport>>, {data: BodyType<ReportingQueryRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiRunReport(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRunReportMutationResult = NonNullable<Awaited<ReturnType<typeof apiRunReport>>>
    export type ApiRunReportMutationBody = BodyType<ReportingQueryRequestDto>
    export type ApiRunReportMutationError = ErrorType<void>

    /**
 * @summary Run a report
 */
export const useApiRunReport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRunReport>>, TError,{data: BodyType<ReportingQueryRequestDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof apiRunReport>>,
        TError,
        {data: BodyType<ReportingQueryRequestDto>},
        TContext
      > => {
      return useMutation(getApiRunReportMutationOptions(options));
    }
    
/**
 * Active keys first, then revoked ones.
 * @summary List API keys
 */
export const listApiKeys = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiKeyDto[]>(
      {url: `/api-keys`, method: 'GET', signal
    },
      options);
    }
  



export const getListApiKeysQueryKey = () => {
    return [
    `/api-keys`
    ] as const;
    }

    
export const getListApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApiKeysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({ signal }) => listApiKeys(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listApiKeys>>>
export type ListApiKeysQueryError = ErrorType<unknown>


/**
 * @summary List API keys
 */

export function useListApiKeys<TData = Awaited<ReturnType<typeof listApiKeys>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeys>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApiKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns the plaintext once. At most 10 active keys.
 * @summary Create an API key
 */
export const createApiKey = (
    createApiKeyDto: BodyType<CreateApiKeyDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CreatedApiKeyDto>(
      {url: `/api-keys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createApiKeyDto, signal
    },
      options);
    }
  


export const getCreateApiKeyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<CreateApiKeyDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<CreateApiKeyDto>}, TContext> => {

const mutationKey = ['createApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiKey>>, {data: BodyType<CreateApiKeyDto>}> = (props) => {
          const {data} = props ?? {};

          return  createApiKey(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKey>>>
    export type CreateApiKeyMutationBody = BodyType<CreateApiKeyDto>
    export type CreateApiKeyMutationError = ErrorType<void>

    /**
 * @summary Create an API key
 */
export const useCreateApiKey = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKey>>, TError,{data: BodyType<CreateApiKeyDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createApiKey>>,
        TError,
        {data: BodyType<CreateApiKeyDto>},
        TContext
      > => {
      return useMutation(getCreateApiKeyMutationOptions(options));
    }
    
/**
 * Takes effect at once on this server.
 * @summary Revoke an API key
 */
export const revokeApiKey = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiKeyDto>(
      {url: `/api-keys/${id}/revoke`, method: 'POST', signal
    },
      options);
    }
  


export const getRevokeApiKeyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{id: string}, TContext> => {

const mutationKey = ['revokeApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeApiKey>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  revokeApiKey(id,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeApiKey>>>
    
    export type RevokeApiKeyMutationError = ErrorType<void>

    /**
 * @summary Revoke an API key
 */
export const useRevokeApiKey = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeApiKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeApiKey>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRevokeApiKeyMutationOptions(options));
    }
    
/**
 * The last 50 rows of api_request_log.
 * @summary Recent calls made with a key
 */
export const listApiKeyRequests = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiRequestLogDto[]>(
      {url: `/api-keys/${id}/requests`, method: 'GET', signal
    },
      options);
    }
  



export const getListApiKeyRequestsQueryKey = (id: string,) => {
    return [
    `/api-keys/${id}/requests`
    ] as const;
    }

    
export const getListApiKeyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listApiKeyRequests>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApiKeyRequestsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeyRequests>>> = ({ signal }) => listApiKeyRequests(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApiKeyRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApiKeyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listApiKeyRequests>>>
export type ListApiKeyRequestsQueryError = ErrorType<unknown>


/**
 * @summary Recent calls made with a key
 */

export function useListApiKeyRequests<TData = Awaited<ReturnType<typeof listApiKeyRequests>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApiKeyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApiKeyRequestsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}
